;(function () {
  'use strict'

  angular.module('deskfy.arts').directive('qrcodeApp', qrcodeApp)

  /* @ngInject */
  function qrcodeApp () {
    return {
      restrict: 'E',
      scope: {
        art: '<'
      },
      templateUrl: '/arts/directives/qrcode-app/qrcode-app-directive.html?$$REVISION$$',
      controller: 'QrcodeController'
    }
  }
})()
